import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { ICommsTemplate, ICommsTemplateSearch } from '../interfaces/comms-template';
import { ICommsTemplatePreviewRequest } from '../interfaces/comms-template-preview-request';
import { ICommsTemplateAttachment } from '../interfaces/comms-template/comms-template-attachment';

@Injectable({
  providedIn: 'root',
})
export class CommsTemplateService extends BaseDataService {
  url = '/api/commsTemplate';
  entityTitle = 'Comms Template';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getCommsTemplates(filter?: ICommsTemplateSearch): Promise<ICommsTemplate[]> {
    let params = this.constructHttpParams(filter);

    return this.handleRequest<ICommsTemplate[]>(
      this.http.get<ICommsTemplate[]>(this.url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  fetchExcludedCustomers(templateId: number) {
    return this.http
      .get<any>(this.url + '/getExcludedCustomers/' + templateId)
      .toPromise()
      .catch(() => {
        console.log('ERROR');
      });
  }

  fetchTemplateFileChoices() {
    return this.handleRequest<string[]>(
      this.http.get<string[]>(this.url + '/templateFiles'),
      this.handlersFactory.getForReadAll(),
    );
  }

  fetchTemplateWrappers() {
    return this.http
      .get<any>(this.url + '/getTemplateWrappers')
      .toPromise()
      .catch(() => {
        console.log('ERROR');
      });
  }

  sendTest(request: ICommsTemplatePreviewRequest) {
    return this.http
      .post<any>(this.url + '/sendTest', {
        commsTemplate: request.commsTemplate,
        previewId: request.previewId,
        previewRecipient: request.previewRecipient,
      })
      .toPromise()
      .catch(() => {
        console.log('ERROR');
      });
  }
  previewTemplate(request: ICommsTemplatePreviewRequest) {
    return this.http
      .post<any>(this.url + '/preview', {
        commsTemplate: request.commsTemplate,
        previewId: request.previewId,
        previewRecipient: request.previewRecipient,
      })
      .toPromise()
      .catch(() => {
        console.log('ERROR');
      });
  }

  previewModel(request: ICommsTemplatePreviewRequest) {
    return this.handleRequest<any>(
      this.http.post<any>(this.url + '/previewModel', {
        commsTemplate: request.commsTemplate,
        previewId: request.previewId,
        previewRecipient: request.previewRecipient,
      }),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }

  deleteTemplate(id) {
    var newUrl = this.url + '/' + id;

    return this.handleRequest<any>(
      this.http.delete<any>(newUrl),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }

  addCommsTemplateExclude(commsTemplateId: number, customerId: number) {
    var newUrl = this.url + '/addExcludedCustomer';

    return this.handleRequest<any>(
      this.http.post<any>(newUrl, { commsTemplateId: commsTemplateId, customerId: customerId }),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }
  removeCommsTemplateExclude(commsTemplateId: number, customerId: number) {
    var newUrl = this.url + '/removeExcludedCustomer/' + commsTemplateId + '/' + customerId;

    return this.handleRequest<any>(
      this.http.delete<any>(newUrl),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  saveTemplate({ commsTemplate }) {
    if (commsTemplate.id == 0 || commsTemplate.id == null) {
      return this.handleRequest<any>(
        this.http.post<ICommsTemplate>(this.url, commsTemplate),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    } else {
      var newUrl = this.url + '/' + commsTemplate.id;

      return this.handleRequest<any>(
        this.http.put<ICommsTemplate>(newUrl, commsTemplate),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    }
  }

  getTemplateAttachments(templateId: number) {
    return this.http
      .get<ICommsTemplateAttachment[]>(this.url + '/getTemplateAttachments/' + templateId)
      .toPromise();
  }

  createTemplateAttachment(dto: ICommsTemplateAttachment) {
    return this.http.post<boolean>(this.url + '/createTemplateAttachment/', dto).toPromise();
  }

  updateTemplateAttachment(dto: ICommsTemplateAttachment) {
    return this.http.put<boolean>(this.url + '/updateTemplateAttachment/', dto).toPromise();
  }

  public deleteTemplateAttachment(id: number) {
    return this.http.delete<any>(this.url + `/deleteTemplateAttachment/${id}`).toPromise();
  }
}
